import React from 'react';
import { Link } from 'react-router-dom';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import { useLanguage } from '../LanguageContext';
import { HomeHeroVisual } from '../components/visuals/DashboardVisuals';
import '../V3.css';

const V3Home = () => {
  const { t } = useLanguage();

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header />
        <div className="v3-hero">
          <h1>{t('home.title')}</h1>
          <p>{t('home.p1')}</p>
          <p><strong>{t('home.p2')}</strong></p>
          <p>{t('home.p3')}</p>
          <HomeHeroVisual />
        </div>

        <section className="v3-block">
          <h2>{t('home.problemsTitle')}</h2>
          <div className="v3-grid2">
            <div className="v3-wire-block">
              <span className="v3-label">{t('home.problem1Label')}</span>
              <strong style={{ fontSize: 17 }}>{t('home.problem1Title')}</strong>
              <p style={{ fontSize: 13, marginTop: 8 }}>{t('home.problem1Desc')}</p>
            </div>
            <div className="v3-wire-block">
              <span className="v3-label">{t('home.problem2Label')}</span>
              <strong style={{ fontSize: 17 }}>{t('home.problem2Title')}</strong>
              <p style={{ fontSize: 13, marginTop: 8 }}>{t('home.problem2Desc')}</p>
            </div>
          </div>
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 15 }}>
            <strong>{t('home.problemsClose')}</strong>
          </p>
        </section>

        <section className="v3-block">
          <h2>{t('home.solutionTitle')}</h2>
          <div className="v3-grid2">
            <Link to="/leadership-development" className="v3-wire-block clickable">
              <span className="v3-label red">{t('common.problem01Solution')}</span>
              <span className="v3-label">{t('common.vertical01')}</span>
              <h3>{t('home.leadershipTitle')}</h3>
              <p style={{ fontSize: 13 }}>{t('home.leadershipDesc')}</p>
              <span className="v3-arrow">→</span>
            </Link>
            <Link to="/hyperlocal-platform" className="v3-wire-block clickable">
              <span className="v3-label red">{t('common.problem02Solution')}</span>
              <span className="v3-label">{t('common.vertical02')}</span>
              <h3>{t('home.hyperlocalTitle')}</h3>
              <p style={{ fontSize: 13 }}>{t('home.hyperlocalDesc')}</p>
              <span className="v3-arrow">→</span>
            </Link>
          </div>
          <p style={{ marginTop: 20 }}><strong>{t('home.solutionClose')}</strong></p>
        </section>

        <div className="v3-cta-strip">{t('home.cta')}</div>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3Home;
